import { render } from "./CustomProvidersView.vue?vue&type=template&id=094a59cc&scoped=true"
import script from "./CustomProvidersView.vue?vue&type=script&lang=js"
export * from "./CustomProvidersView.vue?vue&type=script&lang=js"

import "./CustomProvidersView.vue?vue&type=style&index=0&id=094a59cc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094a59cc"]])

export default __exports__